"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ThemeProvider: true,
  StyleProvider: true,
  DefaultTheme: true,
  styleRenderer: true
};
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _themeProvider["default"];
  }
});
Object.defineProperty(exports, "StyleProvider", {
  enumerable: true,
  get: function get() {
    return _styleProvider["default"];
  }
});
Object.defineProperty(exports, "DefaultTheme", {
  enumerable: true,
  get: function get() {
    return _default["default"];
  }
});
Object.defineProperty(exports, "styleRenderer", {
  enumerable: true,
  get: function get() {
    return _styleRenderer.styleRenderer;
  }
});

require("core-js/es6/array");

var _themeProvider = _interopRequireDefault(require("./theme-provider"));

var _styleProvider = _interopRequireDefault(require("./style-provider"));

var _default = _interopRequireDefault(require("./themes/default"));

var _styleRenderer = require("./style-renderer");

var _atoms = require("./components/atoms");

Object.keys(_atoms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _atoms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _atoms[key];
    }
  });
});

var _hooks = require("./components/hooks");

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hooks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}